import React from "react";
import "../styles/styles.css";

const GenreFilter = ({ genres, selectedGenres, setSelectedGenres }) => {
  const handleChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedGenres([...selectedGenres, value]);
    } else {
      setSelectedGenres(selectedGenres.filter((g) => g !== value));
    }
  };

  return (
    <div className="genre-filter">
      <h4 style={{ color: "var(--color-text)", marginBottom: "0.5rem" }}>
        Filtrar por género:
      </h4>
      <div className="genre-options">
        {genres.map((genre) => (
          <label key={genre} className="genre-label">
            <input
              type="checkbox"
              value={genre}
              checked={selectedGenres.includes(genre)}
              onChange={handleChange}
            />
            {genre}
          </label>
        ))}
      </div>
    </div>
  );
};

export default GenreFilter;